import { render, staticRenderFns } from "./NewLeaderboard.vue?vue&type=template&id=6696bb1c&"
import script from "./NewLeaderboard.vue?vue&type=script&lang=js&"
export * from "./NewLeaderboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports